import { render, staticRenderFns } from "./OmfyButton.vue?vue&type=template&id=cee838d8&"
import script from "./OmfyButton.vue?vue&type=script&lang=js&"
export * from "./OmfyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports